import React from 'react';
import {
  Box,
  Container,
  Typography,
  useTheme,
} from '@mui/material';
import AnimatedElement from './AnimatedElement';

const AboutSection = () => {
  const theme = useTheme();

  return (
    <Box
      id="about"
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: 'primary.white'
      }}
    >
      <Container 
        maxWidth={false} 
        sx={{ 
          maxWidth: '1400px',
          pl: { xs: 2, md: 14 }, // 80px = 10 * 8px (theme spacing)
          pr: 2,
          mx: 'auto',
          mb: 8
        }}
      >
         <AnimatedElement>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '3fr 7fr 1fr' },
            gap: 2,
            alignItems: 'start'
          }}
        >
          {/* Spalte 1: Sektionsüberschrift */}
          
          <Box>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                 fontSize: { xs: '1.6rem', sm: '1.8rem', md: '2.1rem' },
                fontWeight: 500,
                color: '#000',
                lineHeight: 1.2,
                textAlign: 'left'
              }}
            >
              CORPS<br/>
              GUESTPHALIA<br/>
              BERLIN
            </Typography>
            <Box 
              sx={{
                height: '4px', 
                width: '100px', 
                backgroundColor: 'rgb(58, 123, 62)', 
                marginTop: { xs: '20px', sm: '30px', md: '40px' },
                marginBottom: '20px'
              }}
            />
          </Box>

          {/* Spalte 2: Zweispaltiger Fließtext */}
          <Box>
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: '1rem', md: '1.1rem' },
                lineHeight: 1.6,
                color: '#000',
                textAlign: 'left',
                columnCount: { xs: 1, md: 2 },
                columnGap: '2rem',
                margin: 0,
                '& p': {
                  breakInside: 'avoid',
                  pageBreakInside: 'avoid', // Fallback
                  marginTop: 0, // Entfernt Abstand über dem ersten Absatz
                  marginBottom: 2 // Abstand zwischen Absätzen
                },
                '& p:first-of-type': {
                  marginTop: 0 // Explizit für den ersten Absatz
                },
                columnRule: 'none',
                 marginLeft: { xs: '40px', md: 0 }
              }}
            >
              <p>Das Corps Guestphalia Berlin (gesprochen „Westfalia") ist eine traditionsreiche Studentenverbindung, die im Jahre 1845 an der Berliner Friedrich-Wilhelms-Universität, der heutigen Humboldt-Universität, gegründet wurde. Die Verbindung vertritt die Prinzipien der akademischen Freiheit, der Lebensfreundschaft, Toleranz gegenüber Andersdenkenden und der Pflege von Traditionen. Unser Corps betont dabei die Bedeutung der Vielfalt innerhalb unserer Gemeinschaft und begrüßt Studenten aus verschiedenen kulturellen und sozialen Hintergründen.</p>
              <p>Unser Corps Guestphalia ist Teil des Dachverbandes „Kösener Senioren-Convents-Verband" (KSCV), einer der ältesten und größten Korporationsverbände in Deutschland. Im Rahmen dieses Verbandes engagiert sich unsere Verbindung auch in politischen und gesellschaftlichen Diskussionen, beispielsweise in Fragen der Hochschul- und Bildungspolitik.</p>
              <p>Unser Corps legt zudem großen Wert auf die Förderung von Bildung und Wissenschaft. So vergibt sie jährlich Stipendien an Studenten und Doktoranden, um ihre akademische Arbeit zu unterstützen. Auch der Kontakt zu anderen Verbindungen im In- und Ausland ist unserem Corps wichtig, um den Austausch und die Vernetzung von Wissen und Erfahrungen zu fördern.</p>
              <p>Insgesamt steht unser Corps Guestphalia Berlin für eine traditionsreiche und vielseitige Studentenverbindung, die einen Ausgleich zwischen akademischen Fördern und Fordern sowie Spaß an der studentischen Gemeinschaft pflegt.</p>
            </Typography>
          </Box>

          {/* Spalte 3: Gedrehter Text "CORPS" */}
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'center',
              alignItems: 'flex-start',
              height: '100%',
              minHeight: { xs: '100px', md: '400px' }
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                            <div style={{ height: '100px', width: '2px', backgroundColor: '#3a7b3e', marginLeft: '-4px' }}></div>
                            <Typography
                              variant="h3"
                              sx={{
                                fontSize: { xs: '0.8rem', md: '0.9rem' },
                                fontWeight: 500,
                                color: '#000',
                                writingMode: { xs: 'horizontal-tb', md: 'vertical-rl' },
                                textOrientation: { md: 'mixed' },
                                whiteSpace: 'nowrap',
                                letterSpacing: '0.2em',
                                textAlign: 'center',
                              }}
                            >
                              CORPS
                            </Typography>
                          </div>
            
          </Box>
        
        </Box>
          </AnimatedElement>
      </Container>
    </Box>
  );
};

export default AboutSection;